module.exports = __webpack_public_path__ + "media/images/prize__xt-drivechain-86b1ca5bd8aafa213d00435f80c17783.jpg";